/**
 * Maneja errores de carga de imágenes
 * @param {Event} event - Evento de error de imagen
 */
export function handleImageError(event) {
  const defaultImg = '/img/ccdlogolite.png';
  if (event.target.src.indexOf(defaultImg) === -1) {
    event.target.src = defaultImg;
  }
}
